import { Stack } from '@mui/material';
import { StockAiIntake } from '../../stock-ai-intake/stock-ai-intake';
import { FormattedMessage } from 'react-intl';
import StockItemsAutoComplete from '../../StockItemsAutoComplete';
import TextField from '@shared/components/TextField';
import { StockFormControl } from '../stock-item-form';
import { useCurrency } from '@features/currency/currency.hooks';

type PurchaseFormProps = {
  control: StockFormControl;
  unit: string | undefined;
};

export const StockItemPurchaseForm = ({ control, unit }: PurchaseFormProps) => {
  const { preferredCurrency } = useCurrency();
  return (
    <>
      <Stack alignItems="flex-start">
        <StockAiIntake />
      </Stack>
      <StockItemsAutoComplete id="stock-item-purchase-item" fieldPath="id" control={control} />
      <Stack direction="row" spacing={1}>
        <TextField
          id="stock-item-purchase-package-count"
          fieldPath="packageCount"
          label={<FormattedMessage id="stockItem.packageCount" defaultMessage="Počet balení" />}
          type="number"
          required
          control={control}
        />
        <TextField
          id="stock-item-purchase-package-quantity"
          fieldPath="quantity"
          label={
            <FormattedMessage
              id="stockItem.packageQuantity"
              defaultMessage={`Množství v jednom balení v ${unit ?? ''}`}
            />
          }
          type="number"
          fullWidth
          required
          control={control}
        />
      </Stack>
      <TextField
        id="stock-item-purchase-total-price"
        fieldPath="totalPrice"
        label={
          <FormattedMessage
            id="stockItem.totalPrice"
            defaultMessage={`Cena za všechna balení v ${preferredCurrency}`}
          />
        }
        type="number"
        fullWidth
        control={control}
      />
    </>
  );
};
